import { Logger } from './utils/logger.js';
import { ProviderFactory } from './providers/ProviderFactory.js';

class Tracker {
  providerFactory = new ProviderFactory();
  providers = {};
  constructor(params) {
    this.logger = new Logger(params && params.debug ? params.debug : false);
  }
  addProvider(providerOptions) {
    const provider = this.providerFactory.createProvider(providerOptions, this.logger);
    this.providers[providerOptions.name] = provider;
  }
  track(_ref) {
    let {
      providerName,
      payload,
      eventName
    } = _ref;
    const provider = this.providers[providerName];
    if (!provider) {
      this.logger.error('Please add first your provider');
    } else {
      provider.track({
        eventName,
        payload
      });
    }
  }
  setUserId(_ref2) {
    let {
      providerName,
      userId
    } = _ref2;
    const provider = this.providers[providerName];
    if (!provider) {
      this.logger.error('Please add first your provider');
    } else {
      provider.setUserId(userId);
    }
  }
  setUserProperties(_ref3) {
    let {
      providerName,
      properties
    } = _ref3;
    const provider = this.providers[providerName];
    if (!provider) {
      this.logger.error('Please add first your provider');
    } else {
      provider.setUserProperties({
        properties
      });
    }
  }
}

export { Tracker };
//# sourceMappingURL=Tracker.js.map
